/* ==========================================================================
   LEGO FACE — shared behaviour for the marketing sections
   Used by: sections/testimonials.liquid, sections/image-slider.liquid
   Scroll-snap carousels: dots, arrows, keyboard, editor-safe re-init.
   No dependencies. Idempotent — safe to load more than once.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    if (!root || root.dataset.lfReady === 'true') return;

    var track = root.querySelector('[data-lf-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-lf-slide]'));
    if (!slides.length) slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    root.dataset.lfReady = 'true';

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-lf-dot]'));
    var prev = root.querySelector('[data-lf-prev]');
    var next = root.querySelector('[data-lf-next]');

    function step() {
      var gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function currentIndex() {
      if (track.scrollLeft >= maxScroll() - 2) return slides.length - 1;
      var i = Math.round(track.scrollLeft / Math.max(1, step()));
      return Math.min(slides.length - 1, Math.max(0, i));
    }

    function setActive(i) {
      for (var d = 0; d < dots.length; d++) {
        var on = d === i;
        dots[d].classList.toggle('is-active', on);
        if (on) {
          dots[d].setAttribute('aria-current', 'true');
        } else {
          dots[d].removeAttribute('aria-current');
        }
      }
    }

    function go(i) {
      var target = Math.max(0, Math.min(slides.length - 1, i)) * step();
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
      } else {
        track.scrollLeft = target;
      }
    }

    var frame = 0;
    track.addEventListener(
      'scroll',
      function () {
        if (frame) return;
        frame = window.requestAnimationFrame(function () {
          frame = 0;
          setActive(currentIndex());
        });
      },
      { passive: true }
    );

    if (prev) {
      prev.addEventListener('click', function () {
        go(currentIndex() - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        go(currentIndex() + 1);
      });
    }

    for (var d = 0; d < dots.length; d++) {
      dots[d].addEventListener('click', function (event) {
        var index = parseInt(event.currentTarget.getAttribute('data-lf-dot'), 10);
        go(isNaN(index) ? 0 : index);
      });
    }

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(currentIndex() + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(currentIndex() - 1);
      }
    });

    var resizeTimer = 0;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        setActive(currentIndex());
      }, 150);
    });

    setActive(currentIndex());
  }

  function initAll(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var roots = host.querySelectorAll('[data-lf-carousel]');
    for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
  }

  if (window.__lfCarousels) {
    window.__lfCarousels.init();
    return;
  }

  window.__lfCarousels = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
